import { render, staticRenderFns } from "./giveAnalysis.vue?vue&type=template&id=b5057a7a&scoped=true"
import script from "./giveAnalysis.vue?vue&type=script&lang=js"
export * from "./giveAnalysis.vue?vue&type=script&lang=js"
import style0 from "./giveAnalysis.vue?vue&type=style&index=0&id=b5057a7a&prod&lang=less&scoped=true"
import style1 from "./giveAnalysis.vue?vue&type=style&index=1&id=b5057a7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5057a7a",
  null
  
)

export default component.exports